import Vue from 'vue'
import axios from 'axios'
import Qs from 'qs'
import App from './App.vue'

// Import Framework7 Bundle
import Framework7 from 'framework7/framework7-lite.esm.bundle.js'

// Import Framework7-Vue with all components
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js'

// Import CSS of Framework7
import 'framework7/css/framework7.bundle.min.css'

// Init plugin and register all components
Framework7.use(Framework7Vue)

axios.defaults.withCredentials = true

axios.interceptors.request.use(
  config => {
    config.paramsSerializer = params => {
      return Qs.stringify(params, {
        arrayFormat: 'brackets',
        encode: true
      })
    }

    return config
  },
  error => Promise.reject(error)
)

axios.interceptors.response.use(
  response => response,
  error => {
    switch (error.response.status) {
      case 401:
        if (window.location.href.indexOf('/login/') === -1 && window.location.hash.indexOf('/login/') === -1) {
          window.location = '/#!/login/'
        }
        break
    }
    return Promise.reject(error)
  }
)


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
